import { createTheme, adaptV4Theme } from "@mui/material/styles";

import * as dTokens from "ui-common/components/design-tokens";

const resMedGrey = "#E3E7ED";
const resMedRed = "#B02643";
const resMedBlue = dTokens.res_brand_color_007;
const resMedLightBlue = dTokens.res_brand_color_001;

const resMedButton = dTokens.res_brand_color_005;
const resMedHoverButton = "#00497A";

const resMedError = dTokens.color_text_error;
const resMedSuccess = dTokens.color_text_success;

const resMedExtraLight = dTokens.res_grey_50;
const resMedLight = dTokens.res_grey_100;
const resMedLightText = dTokens.res_grey_600;
const resMedDarkerText = dTokens.res_grey_700;

// Hex transparency value to append to hex colour values
const tenPercentTransparency = "1A";

const themeFonts = ["Open Sans Bold", "Open Sans", "sans-serif"].join(",");

const patientTheme = createTheme(adaptV4Theme({
  palette: {
    primary: {
      main: resMedBlue,
    },

    secondary: {
      main: resMedLightBlue, // Used for buttons.
    },

    tertiary: {
      main: "#6F2C91",
    },
    settings: {
      titlebar: "#000000",
      border: "#ebebeb",
    },

    table: {
      header: resMedGrey,
    },
    text: {
      primary: dTokens.res_grey_800,
    },
  },
  typography: {
    fontFamily: themeFonts,
  },
  overrides: {
    MuiFormLabel: {
      root: {
        "&$focused": {
          color: "#000000",
        },
      },
    },
    MuiButton: {
      root: {
        fontFamily: themeFonts,
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: "normal",
        letterSpacing: "1px",
        
        textTransform: "none",

        padding: "10px 24px",
        height: "34px",
        borderRadius: "24px",
        boxShadow: "none",
      },
      label: {
      },
      contained: {
        color: dTokens.c_btn_primary_text_color,
        backgroundColor: resMedButton,
        alignSelf: "stretch",

        "&:hover": {
          backgroundColor: resMedHoverButton,
          boxShadow: "none",
        },
        "&:active": {
          backgroundColor: resMedButton,
          boxShadow: "none",
        },
        "&:disabled": {
          color: dTokens.c_btn_primary_text_color,
          backgroundColor: resMedButton,
          opacity: dTokens.c_btn_opacity_disabled,
          boxShadow: "none",
        },
      },
      outlined: {
        color: resMedButton,
        backgroundColor: dTokens.c_btn_secondary_bgcolor,

        borderWidth: "2px",
        borderStyle: dTokens.c_btn_secondary_border_style,
        borderColor: resMedButton,

        "&:hover": {
          color: resMedHoverButton,
          borderColor: `${resMedHoverButton} !important`,
          backgroundColor: dTokens.c_btn_secondary_bgcolor,
          borderWidth: dTokens.c_btn_secondary_hover_border_width,
        },
        "&:active": {
          color: resMedButton,
          borderColor: resMedButton,
          backgroundColor: `${resMedButton}${tenPercentTransparency}`,
        },
        "&:disabled": {
          color: resMedButton,
          backgroundColor: dTokens.c_btn_secondary_bgcolor,
  
          borderWidth: dTokens.c_btn_secondary_border_width,
          borderStyle: dTokens.c_btn_secondary_border_style,
          borderColor: `${resMedButton} !important`,

          opacity: dTokens.c_btn_opacity_disabled,
        },
      },
      text: {
        padding: "10px 12px",
        color: resMedButton,

        "&:hover": {
          color: resMedHoverButton,
          backgroundColor: dTokens.res_grey_50
        },
        "&:active": {
          color: resMedButton,
          background: "none"
        },
        "&:disabled": {
          color: resMedButton,
          opacity: dTokens.c_btn_opacity_disabled
        }
      },
    },
    MuiChip: {
      root: {
        borderRadius: 4,
      },
    },
    MuiTableCell: {
      root: {
        borderBottom: "none",
        fontSize: "16px",
        lineHeight: "15px",
      },
    },

    MuiListItem: {
      root: {
        "&$selected": { backgroundColor: resMedGrey },
      },
      gutters: {
        paddingTop: "18px",
        paddingBottom: "18px",
      },
    },

    MuiTablePagination: {
      toolbar: {
        backgroundColor: resMedGrey,
      },
    },

    MuiDialogContent: {
      root: {
        fontSize: "16px",
        lineHeight: "20px",
      },
    },
    MuiDialogContentText: {
      root: {
        color: "#000000",
      },
    },
    MuiImageListItemBar: { 
      title: {
        fontSize: "14px",
        color: "#000000"
      }
    }
  },
}));

export default patientTheme;
export {
  resMedGrey,
  resMedRed,
  resMedBlue,
  resMedLightBlue,
  resMedError,
  resMedSuccess,
  resMedExtraLight,
  resMedLight,
  resMedLightText,
  resMedDarkerText,
};
